// Query ID mapping from the Optifund Business Leader Dashboard Frontend
// Implementation Spec (docs/Optifund_Business_Leader_Dashboard_Frontend_Implementation_Spec.txt,
// Section 3). Each key drives the generic BQL runner with a different QUERY_ID.
export enum OptifundDashboardQueryIds {
  "performanceDailyId" = "5712589443039232",
  "performanceWeeklyId" = "5639007098634240",
  "performanceMonthlyId" = "5662745852641280",
  "brandsDailyId" = "5635078948388864",
  "brandsMtdId" = "5682506862952448",
  "usersMainFunnelId" = "5655447696572416",
  "usersLeadToQualifiedId" = "5634233376702464",
  "usersQualifiedByZipId" = "5750789393874944",
  "usersStep1AllId" = "5767776257966080",
  "usersStep1LeadId" = "5721280955285504",
  "usersStep1QualifiedId" = "5700891269136384",
  "usersStep2AllId" = "5732466014814208",
  "usersStep2LeadId" = "5717003704729600",
  "usersStep2QualifiedId" = "5692539998830592",
  "usersStep3AllId" = "5632013348372480",
  "usersStep3LeadId" = "5698612453441536",
  "usersStep3QualifiedId" = "5659117611909120",
  "usersStep4AllId" = "5701736840822784",
  "usersStep4LeadId" = "5138786887401472",
  "usersStep4QualifiedId" = "5688622023966720",
  "usersStep5LeadId" = "5677283847176192",
  "usersStep5QualifiedId" = "5730929465098240",
  "usersStep6AllId" = "5753836807389184",
  "usersStep6LeadId" = "5631580831744000",
  "usersStep6QualifiedId" = "5763672618041344",
  "usersStep7AllId" = "5645672351006720",
  "usersStep7LeadId" = "5706691219816448",
  "usersStep7QualifiedId" = "6264686794244096",
}
